import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    Typography,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import { createWhitelistIpAction, editWhiteListIpAction } from "../../Actions/whiteListpsAction";
import { MyCloseIcon } from "../../Assets/svg/MyIcons";
import { FRONTEND_MESSAGES } from "../../utils/messages";

const { VALIDATION } = FRONTEND_MESSAGES;

const AddEditWhiteListIp = ({
    open,
    handleClose,
    ipDataById,
    setSnackbar,
    getWhiteListIps,
}) => {
    const [buttonDisable, setButtonDisable] = useState(false);
    const [loading, setLoading] = useState(false);
    const validationSchema = yup.object().shape({
        ipAdress: yup
            .string()   
            .trim()
            .required(VALIDATION.REQUIRED_FIELD("IP address"))
            .min(7, VALIDATION.MIN_LENGTH("IP address", 7))
            .max(15, VALIDATION.MAX_LENGTH("IP address", 15))
            .matches(
                /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
                VALIDATION.INVALID_FORMAT("IP address")
            ),
    });

    const formik = useFormik({
         initialValues: {
            ipAdress: ipDataById?.data.ipAddress ? ipDataById.data.ipAddress : "",
            // isActive: ipDataById ? ipDataById.isActive : true,
            // isDeleted: ipDataById ? ipDataById.isDeleted : false,
        },
        validationSchema: validationSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            setButtonDisable(true);
            setLoading(true);
            const ipAdress = values.ipAdress.trim();
            const data = {
                ipAddres: ipAdress,
            };

            if (ipDataById) {
                await editWhiteListIpAction(ipDataById?.data.id, data)
                    .then((res) => {
                        setSnackbar({
                            open: true,
                            message: "IP has been updated successfully",
                            severity: "success",
                        });
                        formik.resetForm();
                        handleClose();
                        getWhiteListIps();
                    })
                    .catch((error) => {
                        setSnackbar({
                            open: true,
                            message: error.message,
                            severity: "error",
                        });

                    })
                    .finally(() => {
                        setLoading(false);
                        setButtonDisable(false);
                    });
            } else {
                await createWhitelistIpAction(data)
                    .then((res) => {
                            setSnackbar({
                                open: true,
                                message: "IP added successfully",
                                severity: "success",
                            });
                        formik.resetForm();
                        handleClose();
                        // getIpData();
                        getWhiteListIps();
                    })
                    .catch((error) => {
                        setSnackbar({
                            open: true,
                            message: error?.response?.data?.message || JSON.parse(error?.response?.data)?.message,
                            severity: "error",
                        });
                    })
                    .finally(() => {
                        setLoading(false);
                        setButtonDisable(false);
                    });
            }
        },
    });

    useEffect(() => {
        if (ipDataById) {
            formik.setFieldValue("ipAdress", ipDataById?.data.ipAddress);
        }
        // eslint-disable-next-line
    }, [ipDataById]);

    const handleIpChange = (e) => {
        formik.setFieldValue(e.target.name, e.target.value.replace(/\s/g, ''));
        formik.setFieldTouched(e.target.name, true, false);
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth>
            <DialogTitle className="fw-semibold fs-2 border-bottom">
                {ipDataById?.id ? "Update IP Details" : "Add IP Address"}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 15,
                }}
            >
                <MyCloseIcon />
            </IconButton>
            <form onSubmit={formik.handleSubmit}>
                <DialogContent>
                    <Typography variant="subtitle2" gutterBottom> IP Address <span className="text-danger ms-1">*</span></Typography>
                    <TextField
                        size="small"
                        placeholder="Enter IP address"
                        margin="normal"
                        name="ipAdress"
                        fullWidth
                        value={formik.values.ipAdress}
                        onChange={handleIpChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.ipAdress && Boolean(formik.errors.ipAdress)}
                        helperText={formik.touched.ipAdress && formik.errors.ipAdress}
                    />
                    <div></div>
                </DialogContent>
                <DialogActions className="px-7 py-5 d-flex justify-content-between border-top-1 border">
                    <button
                        className="btn btn-sm btn-outline btn-outline-primary"
                        onClick={handleClose}
                    >
                        {" Cancel "}
                    </button>
                    <button
                        className="btn btn-sm btn-primary"
                        type="submit"
                        disabled={buttonDisable || loading || !formik.isValid}
                    >
                        {ipDataById ? "Update" : "Add"}
                        {loading ? (
                            <span
                                className="spinner-border spinner-border-sm ms-2"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        ) : null}
                    </button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default AddEditWhiteListIp;
